// src/LocationIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var LocationIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("mask", { id: "ringMask", children: [
        /* @__PURE__ */ jsx("rect", { width: 18, height: 18, fill: "white" }),
        /* @__PURE__ */ jsx("circle", { cx: "9", cy: "7", r: "0.5", fill: "black" })
      ] }) }),
      /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.1377 7.52716C4.1377 11.04 7.21081 13.945 8.57105 15.0587L8.57159 15.0592C8.76663 15.2189 8.86419 15.2988 9.00956 15.3397C9.12266 15.3715 9.289 15.3715 9.40209 15.3397C9.5476 15.2987 9.64542 15.2187 9.84082 15.0587C11.2011 13.945 14.274 11.04 14.274 7.52713C14.274 6.19774 13.7401 4.9228 12.7896 3.98277C11.8392 3.04275 10.5501 2.51465 9.20591 2.51465C7.86175 2.51465 6.5726 3.04274 5.62213 3.98276C4.67166 4.92279 4.1377 6.19776 4.1377 7.52716Z",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: "9", cy: "7", r: "2.5", fill: "currentColor", mask: "url(#ringMask)" })
      ] })
    ]
  }
);

export {
  LocationIcon
};
